<template src="./upcomingevent.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
import LicenceCategories from "@/assets/json_data/licence_categories.json";
var moment = require("moment");
export default {
  components: {},
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
    datetime: function (data) {
      if (data == "" || data == null) {
        return "--";
      }
      var reqdString = "";
      for (let i = 0; i < 10; i++) {
        reqdString += data[i];
      }
      var arr = reqdString.split("-");
      reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
      var reqTString = "";
      for (let i = 11; i < 16; i++) {
        reqTString += data[i];
      }
      var arr = reqTString.split(":");
      if (arr[0] >= 12) {
        reqTString = arr[0] - 12 + ":" + arr[1] + " PM";
      } else {
        reqTString = arr[0] + ":" + arr[1] + " AM";
      }
      return reqdString + " " + reqTString;
    },
  },
  props: {
    RequestFor: String,
    RequestStatus: String,
    height: String / Number,
    DriverId: String / Number,
    VehicleId: String / Number,
    BranchID: String / Number,
    AssetsId: String / Number,
  },
  data() {
    return {
      newHeight: "350px",
      UpcomingEvent: [],
      CalenderEvent: [],
      OtherData: [],
      VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      Event: {},
      Branches: {},
      ShowEventActionModel: "",
      EventActionModelHeading: "",
      SubmitEvent: {},
      TaskFilter: "All",
      BranchFilter: "",
      PopupLoader: false,
      UpcomingEventListLoader: false,
      trailersModule: false,
      assetsModule: false,
      branchModule: false,
      MileageUnit: "Miles",
      file: "",
      Categories: LicenceCategories,
      ViewDocument: {},
      ShowViewDetailModel: false,
      MOTType: "MOT",
      ShowVehicleChecksMarkAsComplete: false,
    };
  },
  computed: {},
  mounted() {
    var CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (CompanyData.mileage_unit == 2) {
      this.MileageUnit = "KM";
    }
    //check account permission
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    this.FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(
      this.FleetSubscription.fleet_modules
    );
    if (
      AccountPermissions &&
      AccountPermissions["Vehicle Checks"] &&
      AccountPermissions["Vehicle Checks"]["enable"]
    ) {
      if (
        AccountPermissions["Vehicle Checks"]["vehicle_checks_mark_as_complete"]
      ) {
        this.ShowVehicleChecksMarkAsComplete = true;
      }
    }

    if (!FleetSubscriptionModules["Hierarchy System"]) {
      this.ShowVehicleChecksMarkAsComplete = true;
    }

    if (typeof this.height != "undefined") {
      this.newHeight = this.height + "px";
    }
    this.OtherData.redStatusCnt = 0;
    //this.GetCompanySubscription();
    this.GetBranches();
    this.GetCompanySubscriptionModule();
    //this.GetUpcomingEventList();
    this.GetUpcomingEventListVehicle();
    this.initSubmitEventObject();
  },
  methods: {
    GetBranches() {
      var obj = { token: localStorage.getItem("token"), select_branch: true };
      Axios.post(Endpoints.Branch.List, obj).then((Response) => {
        if (Response.data.success) {
          this.Branches = Response.data.records;
        }
      });
    },
    GetCompanySubscriptionModule() {
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var fleet_modules = JSON.parse(FleetSubscription["fleet_modules"]);
      const isTrailer = fleet_modules["Trailers"];
      if (isTrailer) {
        this.trailersModule = true;
      }
      const isBranches = fleet_modules["Branches"];
      var CompanyData = JSON.parse(localStorage.getItem("Company"));
      var NoOfBranches = CompanyData.no_of_branches;
      if (isBranches && NoOfBranches > 0) {
        this.branchModule = true;
      }
      const isAssets = fleet_modules["Assets"];
      if (isAssets) {
        this.assetsModule = true;
      }

      if (
        (this.RequestFor == "VehicleProfile" ||
          this.RequestFor == "TrailerProfile" ||
          this.RequestFor == "DriverProfile") &&
        this.BranchID == 0
      ) {
        this.branchModule = false;
      }
    },
    GetCompanySubscription() {
      var FleetSubscriptionModules = JSON.parse(
        JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
      );
      const isTrailer = FleetSubscriptionModules.Trailers;
      if (isTrailer) {
        this.trailersModule = true;
      }
    },
    initSubmitEventObject() {
      var user = JSON.parse(localStorage.getItem("User"));
      this.SubmitEvent = {
        action: 0,
        date_fixed: "",
        notes: "",
        confirm: false,
        licence_category: "",
        licence_number: "",
        licence_expiry_date: "",
        cpc_expiry_date: "",
        adr_expiry_date: "",
        mot_appointment_date: "",
        mot_passed: "",
        pmi_appointment_date: "",
        pmi_passed: "",
        psv_appointment_date: "",
        psv_passed: "",
        service_booked_date: "",
        serviced_date: "",
        next_service_date: "",
        serviced_due_month: "1 Year",
        serviced_due_miles: "10000",
        serviced_due_soonest: "1",
        sorn: false,
        tax_auto_renew: false,
        tax_renew_date: "",
        action_username: user.forename + " " + user.surname,
        insurance_auto_renew: false,
        insurance_renew_date: "",
        service_document: "",
        service_document_name: "",
        penalty_point: "",
      };
    },
    GetUpcomingEventList() {
      this.UpcomingEventListLoader = true;

      var obj = { token: localStorage.getItem("token") };
      obj.RequestFor = this.RequestFor;
      if (this.RequestFor == "AssetsProfile") {
        obj.AssetId = this.VehicleId;
      } else {
        obj.VehicleId = this.VehicleId;
      }
      obj.DriverId = this.DriverId;

      Axios.post(Endpoints.Dashboard.UpcomingEvent, obj).then((Response) => {
        this.UpcomingEventListLoader = false;
        if (Response.data.success) {
          this.UpcomingEvent = Response.data.upcoming_event;
          this.CalenderEvent = Response.data.calender_event;
          this.OtherData = Response.data.other_data;
          var ActionsNeededCount = 0;
          this.CalenderEvent.forEach((element, index) => {
            if (element.status == "red") {
              ActionsNeededCount++;
            }
            if (element.status == "yellow") {
              ActionsNeededCount++;
            }
          });
          if (document.getElementById("ActionsNeededCount")) {
            document.getElementById("ActionsNeededCount").innerHTML =
              ActionsNeededCount;
            //document.getElementById("ActionsNeededCount").innerHTML = this.CalenderEvent.length;
            if (this.OtherData.redStatusCnt >= 1) {
              document.getElementsByClassName("urgent-task-btn")[0].innerHTML =
                this.OtherData.redStatusCnt + " Urgent Tasks Required";
              document.getElementsByClassName(
                "urgent-task-btn"
              )[0].style.display = "block";
            } else {
              document.getElementsByClassName(
                "urgent-task-btn"
              )[0].style.display = "none";
            }
          }
        }
      });
    },
    SetUpcomingEventListData(data, sorting = false) {
      data.upcoming_event.forEach((element, index) => {
        this.UpcomingEvent.push(element);
      });
      data.calender_event.forEach((element, index) => {
        this.CalenderEvent.push(element);
      });
      if (data.other_data && data.other_data.redStatusCnt > 0) {
        if (this.OtherData.redStatusCnt) {
          this.OtherData.redStatusCnt =
            this.OtherData.redStatusCnt + data.other_data.redStatusCnt;
        } else {
          this.OtherData.redStatusCnt = data.other_data.redStatusCnt;
        }
      }
      if (sorting) {
        this.UpcomingEvent.sort((a, b) => a.date3 - b.date3);
        const expired = this.UpcomingEvent.filter(
          (event) => event.status == "red"
        );
        const warning = this.UpcomingEvent.filter(
          (event) => event.status == "yellow"
        );
        const upcoming = this.UpcomingEvent.filter(
          (event) => event.status == "orange"
        );
        this.UpcomingEvent = [...expired, ...warning, ...upcoming];
      }
      //console.log('UpcomingEvent',this.UpcomingEvent)
      //console.log('CalenderEvent',this.CalenderEvent)
      //console.log('OtherData',this.OtherData)

      var ActionsNeededCount = 0;
      this.CalenderEvent.forEach((element, index) => {
        if (element.status == "red") {
          ActionsNeededCount++;
        }
        if (element.status == "yellow") {
          ActionsNeededCount++;
        }
      });

      if (document.getElementById("ActionsNeededCount")) {
        document.getElementById("ActionsNeededCount").innerHTML =
          ActionsNeededCount;
        if (this.OtherData.redStatusCnt >= 1) {
          document.getElementsByClassName("urgent-task-btn")[0].innerHTML =
            this.OtherData.redStatusCnt + " Urgent Tasks Required";
          document.getElementsByClassName("urgent-task-btn")[0].style.display =
            "block";
        } else {
          document.getElementsByClassName("urgent-task-btn")[0].style.display =
            "none";
        }
      }
    },
    GetUpcomingEventListVehicle() {
      this.UpcomingEvent = [];
      this.CalenderEvent = [];
      this.OtherData = [];
      this.UpcomingEventListLoader = true;

      var obj = { token: localStorage.getItem("token") };
      obj.RequestFor = this.RequestFor;
      if (this.RequestFor == "AssetsProfile") {
        obj.AssetId = this.VehicleId;
      } else {
        obj.VehicleId = this.VehicleId;
      }
      obj.DriverId = this.DriverId;

      Axios.post(Endpoints.Dashboard.UpcomingEventVehicle, obj).then(
        (Response) => {
          this.UpcomingEventListLoader = false;
          if (Response.data.success) {
            this.GetUpcomingEventListVehicleChecks();
            this.SetUpcomingEventListData(Response.data);
          }
        }
      );
    },
    GetUpcomingEventListVehicleChecks() {
      var obj = { token: localStorage.getItem("token") };
      obj.RequestFor = this.RequestFor;
      if (this.RequestFor == "AssetsProfile") {
        obj.AssetId = this.VehicleId;
      } else {
        obj.VehicleId = this.VehicleId;
      }
      obj.DriverId = this.DriverId;

      Axios.post(Endpoints.Dashboard.UpcomingEventVehicleChecks, obj).then(
        (Response) => {
          if (Response.data.success) {
            this.GetUpcomingEventListVehicleDocuments();
            this.SetUpcomingEventListData(Response.data);
          }
        }
      );
    },
    GetUpcomingEventListVehicleDocuments() {
      var obj = { token: localStorage.getItem("token") };
      obj.RequestFor = this.RequestFor;
      if (this.RequestFor == "AssetsProfile") {
        obj.AssetId = this.VehicleId;
      } else {
        obj.VehicleId = this.VehicleId;
      }
      obj.DriverId = this.DriverId;

      Axios.post(Endpoints.Dashboard.UpcomingEventDocuments, obj).then(
        (Response) => {
          if (Response.data.success) {
            this.GetUpcomingEventListVehicleDrivers();
            this.SetUpcomingEventListData(Response.data);
          }
        }
      );
    },
    GetUpcomingEventListVehicleDrivers() {
      var obj = { token: localStorage.getItem("token") };
      obj.RequestFor = this.RequestFor;
      if (this.RequestFor == "AssetsProfile") {
        obj.AssetId = this.VehicleId;
      } else {
        obj.VehicleId = this.VehicleId;
      }
      obj.DriverId = this.DriverId;

      Axios.post(Endpoints.Dashboard.UpcomingEventDrivers, obj).then(
        (Response) => {
          if (Response.data.success) {
            if (this.assetsModule) {
              this.GetUpcomingEventListAssets();
            }
            this.SetUpcomingEventListData(Response.data, true);
          }
        }
      );
    },
    GetUpcomingEventListAssets() {
      var obj = { token: localStorage.getItem("token") };
      obj.RequestFor = this.RequestFor;
      if (this.RequestFor == "AssetsProfile") {
        obj.AssetsId = this.AssetsId;
      }

      Axios.post(Endpoints.Dashboard.UpcomingEventAssets, obj).then(
        (Response) => {
          if (Response.data.success) {
            this.SetUpcomingEventListData(Response.data, true);
          }
        }
      );
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    UploadFile() {
      this.PopupLoader = true;
      let formData = new FormData();
      formData.append("token", localStorage.getItem("token"));
      formData.append("storage_type", "CFV");
      formData.append("file", this.file);
      Axios.post(Endpoints.File.Upload, formData).then((Response) => {
        this.PopupLoader = false;
        if (Response.data.success == true) {
          this.SubmitEvent.service_document = Response.data.file;
          this.SubmitEvent.service_document_name = this.file.name;
          this.$swal
            .fire("File Uploaded Successfully", "", "success")
            .then(() => {});
        } else {
          this.$swal
            .fire("Error in File Uploading", "", "error")
            .then(() => {});
        }
      });
    },
    ShowEventAction(event) {
      this.ShowEventActionModel = true;
      console.log("event", event);
      this.Event = event;
      if (event.type == "vehiclecheck" && event.status == "yellow") {
        this.EventActionModelHeading =
          this.RequestFor == "TrailerList" ||
          this.RequestFor == "TrailerProfile"
            ? "Trailer Check Warning Action"
            : "Vehicle Check Warning Action";
      }
      if (event.type == "vehiclecheck" && event.status == "red") {
        this.EventActionModelHeading =
          this.RequestFor == "TrailerList" ||
          this.RequestFor == "TrailerProfile"
            ? "Trailer Check Failure Action"
            : "Vehicle Check Failure Action";
      }

      if (event.type == "document") {
        this.EventActionModelHeading = "Document Expire";
      }

      if (event.type == "driver" && event.type2 == "license") {
        this.EventActionModelHeading = "Licence Expire";
      }

      if (event.type == "driver" && event.type2 == "cpc") {
        this.EventActionModelHeading = "CPC Expire";
      }

      if (event.type == "driver" && event.type2 == "adr") {
        this.EventActionModelHeading = "ADR Expire";
      }

      if (event.type == "vehicle" && event.type2 == "mot_due") {
        this.EventActionModelHeading = event.event;
      }

      if (event.type == "vehicle" && event.type2 == "psv_date") {
        this.EventActionModelHeading = "PSV Expire";
      }

      if (event.type == "vehicle" && event.type2 == "next_pmi_due") {
        this.EventActionModelHeading = "PMI Expire";
      }

      if (event.type == "vehicle" && event.type2 == "mot_appointment") {
        this.EventActionModelHeading = event.event;
      }

      if (event.type == "vehicle" && event.type3) {
        this.MOTType = event.type3;
      }

      if (event.type == "vehicle" && event.type2 == "pmi_appointment") {
        this.EventActionModelHeading = "PMI Appointment";
      }

      if (event.type == "vehicle" && event.type2 == "service_due") {
        this.EventActionModelHeading = "Service Due";
      }

      if (event.type == "vehicle" && event.type2 == "service_appointment") {
        this.EventActionModelHeading = "Service Appointment";
      }

      if (event.type == "vehicle" && event.type2 == "tax_due") {
        this.EventActionModelHeading = "Tax Due";
      }

      if (event.type == "assets" && event.type2 == "service_due") {
        this.EventActionModelHeading = "Assets Service Due";
      }
    },
    ShowEventActionSubmit() {
      console.log("event", this.Event);
      console.log("SubmitEvent", this.SubmitEvent);
      var error = false;
      var errorStr = "";

      /* check error for vehicle check*/
      if (this.Event.type == "vehiclecheck") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (this.SubmitEvent.action == 1 && this.SubmitEvent.date_fixed == "") {
          error = true;
          errorStr += "<li>Please Select Date Fixed</li>";
        }
        if (this.SubmitEvent.action == 3 && !this.SubmitEvent.confirm) {
          error = true;
          errorStr +=
            "<li>Please Confirm Clear warning without addressing</li>";
        }
      }

      /* check error for document*/
      if (this.Event.type == "document") {
        if (!this.SubmitEvent.confirm) {
          error = true;
          errorStr +=
            "<li>Please Check Clear document from upcoming and expired tasks list</li>";
        }
      }

      /* check error for driver license*/
      if (this.Event.type == "driver" && this.Event.type2 == "license") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (
          this.SubmitEvent.action == 1 &&
          this.SubmitEvent.licence_expiry_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Enter Licence Expiry Date</li>";
        }
      }

      /* check error for driver license check*/
      if (this.Event.type == "driver" && this.Event.type2 == "license_check") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (
          this.SubmitEvent.action == 2 &&
          this.SubmitEvent.penalty_point == ""
        ) {
          error = true;
          errorStr += "<li>Please Enter Penalty Point</li>";
        }
      }

      /* check error for driver CPC*/
      if (this.Event.type == "driver" && this.Event.type2 == "cpc") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (
          this.SubmitEvent.action == 1 &&
          this.SubmitEvent.cpc_expiry_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Enter CPC Expiry Date</li>";
        }
      }

      /* check error for driver ADR*/
      if (this.Event.type == "driver" && this.Event.type2 == "adr") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (
          this.SubmitEvent.action == 1 &&
          this.SubmitEvent.adr_expiry_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Enter ADR Expiry Date</li>";
        }
      }

      /* check error for MOT Due*/
      if (this.Event.type == "vehicle" && this.Event.type2 == "mot_due") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (
          this.SubmitEvent.action == 1 &&
          this.SubmitEvent.mot_appointment_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select Date of MOT Appointment</li>";
        }

        if (this.SubmitEvent.action == 2 && this.SubmitEvent.mot_passed == "") {
          error = true;
          errorStr += "<li>Please Select Date of passed MOT</li>";
        }
      }

      /* check error for PMI Due*/
      if (this.Event.type == "vehicle" && this.Event.type2 == "pmi_due") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (
          this.SubmitEvent.action == 1 &&
          this.SubmitEvent.pmi_appointment_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select Date of PMI Appointment</li>";
        }

        if (this.SubmitEvent.action == 2 && this.SubmitEvent.pmi_passed == "") {
          error = true;
          errorStr += "<li>Please Select Date of passed PMI</li>";
        }
      }

      /* check error for PSV Date*/
      if (this.Event.type == "vehicle" && this.Event.type2 == "psv_date") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (
          this.SubmitEvent.action == 1 &&
          this.SubmitEvent.psv_appointment_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select Date of PSV Appointment</li>";
        }

        if (this.SubmitEvent.action == 2 && this.SubmitEvent.psv_passed == "") {
          error = true;
          errorStr += "<li>Please Select Date of passed PSV</li>";
        }
      }

      /* check error for MOT Appointment*/
      if (this.Event.type == "vehicle" && this.Event.type2 == "mot_appointment") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (this.SubmitEvent.action == 1 && this.SubmitEvent.mot_passed == "") {
          error = true;
          errorStr += "<li>Please Select Date of passed MOT</li>";
        }
        if (
          this.SubmitEvent.action == 2 &&
          this.SubmitEvent.mot_appointment_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select Date of MOT Appointment</li>";
        }
      }

      /* check error for PMI Appointment*/
      if (this.Event.type == "vehicle" && this.Event.type2 == "pmi_appointment") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (this.SubmitEvent.action == 1 && this.SubmitEvent.pmi_passed == "") {
          error = true;
          errorStr += "<li>Please Select Date of passed PMI</li>";
        }
        if (
          this.SubmitEvent.action == 2 &&
          this.SubmitEvent.pmi_appointment_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select Date of PMI Appointment</li>";
        }
      }

      /* check error for PSV Appointment*/
      if (this.Event.type == "vehicle" && this.Event.type2 == "psv_appointment") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (this.SubmitEvent.action == 1 && this.SubmitEvent.psv_passed == "") {
          error = true;
          errorStr += "<li>Please Select Date of passed PSV</li>";
        }
        if (
          this.SubmitEvent.action == 2 &&
          this.SubmitEvent.psv_appointment_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select Date of PSV Appointment</li>";
        }
      }

      /* check error for Service Due*/
      if (this.Event.type == "vehicle" && this.Event.type2 == "service_due") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (
          this.SubmitEvent.action == 1 &&
          this.SubmitEvent.service_booked_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select Date of Service Appointment</li>";
        }
        if (
          this.SubmitEvent.action == 2 &&
          this.SubmitEvent.serviced_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select When was this Vehicle Serviced</li>";
        }
      }

      /* check error for Service Appointment*/
      if (this.Event.type == "vehicle" && this.Event.type2 == "service_appointment") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }
        if (
          this.SubmitEvent.action == 1 &&
          this.SubmitEvent.serviced_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select When was this Vehicle Serviced</li>";
        }
      }

      /* check error for Tax Due*/
      if (this.Event.type == "vehicle" && this.Event.type2 == "tax_due") {
        if (
          this.SubmitEvent.sorn == false &&
          this.SubmitEvent.tax_auto_renew == false &&
          this.SubmitEvent.tax_renew_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select Any Action</li>";
        }
      }

      /* check error for Tax Due*/
      if (this.Event.type == "vehicle" && this.Event.type2 == "insurance_expire") {
        if (
          this.SubmitEvent.insurance_auto_renew == false &&
          this.SubmitEvent.insurance_renew_date == ""
        ) {
          error = true;
          errorStr += "<li>Please Select Any Action</li>";
        }
      }

      /* check error for Assets Service Due*/
      if (this.Event.type == "assets" && this.Event.type2 == "service_due") {
        if (this.SubmitEvent.action < 1) {
          error = true;
          errorStr += "<li>Please Select Action</li>";
        }        
        if (this.SubmitEvent.action == 2 && this.SubmitEvent.serviced_date == "") {
          error = true;
          errorStr += "<li>Please Select When was this Assets Serviced</li>";
        }
      }

      if (error == true) {
        this.$swal("Following Error Found!", errorStr, "error").then(() => {});
      } else {
        this.$swal({
          title: "Updating Event...",
          text: "Please wait...",
          imageUrl: require("@/assets/images/LoadingTwo.gif"),
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        Axios.post(Endpoints.Dashboard.UpcomingEventSubmit, {
          token: localStorage.getItem("token"),
          Event: this.Event,
          SubmitEvent: this.SubmitEvent,
        }).then((Response) => {
          if (Response.data.success == true) {
            this.ShowEventActionModel = false;
            this.GetUpcomingEventList();
            this.initSubmitEventObject();
            this.$swal("Event Updated Successfully", "", "success").then(
              () => {}
            );
          } else {
            this.$swal(Response.data.message, "", "error").then(() => {});
          }
        });
      }
    },
    ViewDetailDocument(document) {
      this.ViewDocument = document;
      this.ShowViewDetailModel = true;
    },
  },
};
</script>

<style type="text/css">
.UpcomingEventList td {
  vertical-align: top !important;
  padding-top: 5px !important;
  font-weight: normal !important;
}
.UpcomingEventList td.statusbtn .btn,
.UpcomingEventList td.actionbtn .btn {
  width: 100%;
}
.UpcomingEventList td.event,
.UpcomingEventList td.vrm {
  text-transform: capitalize;
}
.UpcomingEventList .completebtn.btn-primary:hover {
  background-color: #51bb25 !important;
  border-color: #51bb25 !important;
}
#ShowEventActionModel span.plate {
  display: inline-flex;
  vertical-align: top;
}
#ShowEventActionModel .form-control-check {
  margin-left: 10px;
  margin-right: 3px;
  vertical-align: text-top;
}
</style>
